import { render, staticRenderFns } from "./BasicReward.vue?vue&type=template&id=0d85d575&scoped=true&"
import script from "./BasicReward.vue?vue&type=script&lang=js&"
export * from "./BasicReward.vue?vue&type=script&lang=js&"
import style0 from "./BasicReward.vue?vue&type=style&index=0&id=0d85d575&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d85d575",
  null
  
)

export default component.exports